export default {
  mounted() {
      document.documentElement.setAttribute("data-fitter", "true");
        let fadeUpObserve = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              e.target.classList.add("in-view");
              fadeUpObserve.unobserve(e.target);
            }
          });
        });

        document
          .querySelectorAll(
            ".scroll-fade-up, .scroll-fade-right, .scroll-fade-left"
          )
          .forEach((el) => fadeUpObserve.observe(el));
        
        // 常见问题
         function initPublicContainer4Class() {
            if(!document.querySelector(".container4 h2")) return;
                document
                    .querySelector(".container4 h2")
                    .classList.add("title-48_bold", "md-title-24_bold");
                document.querySelectorAll(".container4 .QA-title").forEach((i) => {
                    i.classList.add("subtitle-18_medium", "md-body-16_medium");
                });
                document.querySelectorAll(".container4 .QA-li").forEach((i) => {
                    i.classList.add("content-16_regular", "md-content-14_regular");
                });
            }
            initPublicContainer4Class();
            let expendSpan = document.querySelectorAll(".QA-item .QA-title");
            expendSpan && expendSpan.forEach((item) => {
                item.insertAdjacentHTML(
                    "beforeend",
                    '<span class="iconfont icon-show" style="color:var(--ebc-text-secondary)"></span><span class="iconfont icon-close2" style="color:var(--ebc-text-secondary)"></span>'
                );
                item.addEventListener("click", function () {
                    this.parentNode.classList.toggle("showList");
                });
            });
  },
  destroyed() {
    document.documentElement.removeAttribute("data-fitter");
  },
};
